<template>
  <div class="page-container" ref="container">
    <div class="page-content">
      <div class="content-1">
        <header>
          <img src="@/assets/logo.png" alt="默往APP官网Logo" class="logo-cls" />
        </header>
        <div class="flex-box content-flex-1">
          <img src="@/assets/newpc/banner_1.png" alt="默往APP功能展示" class="banner-2" />
          <div class="flex-1">
            <h1>默往APP</h1>
            <p>
              默往是一款专为熟人好友设计的私密安全的聊天软件，提供高效便捷、私密安全的沟通方式，让你和你关心的人沟通更高效、更安全。
            </p>
            <h2>立即下载，开启安全沟通</h2>
            <p>支持iOS、Android、Windows、macOS等平台下载，随时随地畅享无缝聊天体验。</p>
            <div class="flex-box mar-top">
              <el-popover placement="top" trigger="hover" popper-class="download-popover">
                <div class="down-item">
                  <div class="down-hide">
                    <img src="@/assets/qrcode_ios.png" alt="iOS应用下载二维码" class="qr-img-cls" />
                    <div style="font-weight: bold">扫码下载，开启安全沟通</div>
                  </div>
                </div>
                <div class="down-btn-cls" slot="reference">
                  <img :src="hoveredButton === 'ios' ? require('@/assets/newpc/ios_on.png') : require('@/assets/newpc/ios_default.png')"
                       @mouseover="hoveredButton = 'ios'" @mouseleave="hoveredButton = null" alt="iOS下载按钮" class="img-cls">
                </div>
              </el-popover>
              <el-popover placement="top" trigger="hover" popper-class="download-popover">
                <div class="down-item">
                  <div class="down-hide">
                    <img src="@/assets/qrcode_and.png" alt="Android应用下载二维码" class="qr-img-cls" />
                    <div style="font-weight: bold">扫码下载，开启安全沟通</div>
                  </div>
                </div>
                <div class="down-btn-cls" slot="reference">
                  <img :src="hoveredButton === 'and' ? require('@/assets/newpc/and_on.png') : require('@/assets/newpc/and_default.png')"
                       @mouseover="hoveredButton = 'and'" @mouseleave="hoveredButton = null" alt="Android下载按钮" class="img-cls">
                </div>
              </el-popover>
              <div class="down-btn-cls">
                <img :src="hoveredButton === 'windows' ? require('@/assets/newpc/windows_on.png') : require('@/assets/newpc/windows_default.png')"
                     @mouseover="hoveredButton = 'windows'" @mouseleave="hoveredButton = null" @click="download('windows')" alt="Windows下载按钮" class="img-cls">
              </div>
              <div class="down-btn-cls">
                <img :src="hoveredButton === 'mac' ? require('@/assets/newpc/mac_on.png') : require('@/assets/newpc/mac_default.png')"
                     @mouseover="hoveredButton = 'mac'" @mouseleave="hoveredButton = null" @click="download('mac')" alt="Mac下载按钮" class="img-cls">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="content-2">
        <h2>重要的事默往说</h2>
        <ul class="flex-box sub-title-cls">
          <li>端到端加密</li>|
          <li>纵深防御</li>|
          <li>智能语音识别</li>|
          <li>超级群组</li>
        </ul>
        <ul class="flex-box use-list-cls">
          <li v-for="(item, index) in useList" :key="index" class="flex-1 use-item-cls">
            <img class="icon-cls" :src="item.icon" alt="功能特性图标" />
            <h4>{{ item.title }}</h4>
            <p>{{ item.msg }}</p>
          </li>
        </ul>
      </div>

      <div class="content-3">
        <div class="flex-box">
          <div class="flex-1">
            <h3>全媒介畅聊体验</h3>
            <p>智能语音识别，多种消息格式，满足全方位高效沟通需求</p>
            <p><span>智能语音识别：</span>发送语音时可选择转为文字或“语音+文字”组合，能看能听，沟通效率倍增，同时，支持发送180秒语音。</p>
            <p><span>多种消息格式：</span>支持文字/图片/视频/长语音/文件等多种格式，满足不同场景的沟通需求。</p>
            <p><span>高清视频通话：</span>面对面交流，拉近彼此距离，让每条消息都能准确传达，每次沟通都高效顺畅。</p>
          </div>
          <img src="@/assets/newpc/banner_2.png" alt="全媒介畅聊体验" class="banner-3" />
        </div>
      </div>

      <div class="flex-box content-4">
        <img src="@/assets/newpc/banner_3.png" alt="端到端加密安全" class="banner-4" />
        <div class="flex-1">
          <h3>端到端加密，绝对私密安全</h3>
          <p>采用端到端加密技术，确保通信绝对私密，防止被恶意监控或窃取</p>
          <p><span>通信加密：</span>全程端到端加密，防止被恶意监控或窃取。</p>
          <p><span>本地加密：</span>消息本地加密存储，杜绝云端泄露风险。</p>
          <p><span>完全掌控：</span>用户自主控制数据权限，真正实现隐私自主。</p>
        </div>
      </div>
    </div>

    <div class="content-5">
      <div class="flex-box">
        <div class="flex-1">
          <h3>生物识别安全锁</h3>
          <p>多重防护机制，确保本地访问安全</p>
          <p><span>多种解锁方式：</span>支持指纹、手势、数字密码快速解锁，便捷又安全。</p>
          <p><span>灵活触发：</span>可设置超时自动锁定，或摇晃手机自动上锁。</p>
          <p><span>隐私终极防护：</span>防范手机借人、意外丢失时的隐私泄露风险，默往给你多一重安全保障。</p>
        </div>
        <img src="@/assets/newpc/banner_4.png" alt="生物识别安全锁" class="banner-5" />
      </div>
    </div>

    <div class="flex-box content-6">
      <img src="@/assets/newpc/banner_5.png" alt="企业级群组管理" class="banner-6" />
      <div class="flex-1">
        <h3>企业级群组管理</h3>
        <p>默往支持创建2000人超级群组，千人同群，管理高效，安全无忧</p>
        <p><span>截屏防护：</span>实时监测并通知截屏行为，可设置自动踢出群聊，保护聊天隐私安全。</p>
        <p><span>群员保护：</span>禁止群内互加好友，防止骚扰和挖人，保护成员隐私，营造良好聊天环境。</p>
        <p><span>管理工具：</span>管理员撤回群员消息、定时清理等管理功能让您的群管理变得轻松高效，秩序井然。</p>
      </div>
    </div>

    <div class="content-7">
      <div class="flex-box">
        <div class="flex-1">
          <h3>消息交互，高效便捷</h3>
          <p>丰富智能的交互操作，让沟通与管理变得简单轻松</p>
          <p><span>状态可见：</span>精准的已读/未读状态显示，重要信息是否送达一目了然。</p>
          <p><span>精准回复：</span>支持引用回复功能，针对性回应对话中的特定内容，避免误解，让讨论更有条理。</p>
          <p><span>文本大爆炸：</span>长按文本可智能拆分精准选词、单独复制或转发，提升效率让沟通回归本质。</p>
        </div>
        <img src="@/assets/newpc/banner_6.png" alt="消息交互高效便捷" class="banner-7" />
      </div>
    </div>

    <div class="gradient-box"></div>
    <div class="bottom-box">
      <div class="btm-cls">
        <h2>默往，让每一次对话都值得托付。</h2>
        <p>现在就开始，与您的重要之人，享受高强度加密守护下的私密沟通体验，让每一次交流都更安全、更私密、更值得安心托付。</p>
        <div class="flex-box mar-top">
          <el-popover placement="top" trigger="hover" popper-class="download-popover">
            <div class="down-item">
              <div class="down-hide">
                <img src="@/assets/qrcode_ios.png" alt="iOS应用下载二维码" class="qr-img-cls" />
                <div style="font-weight: bold">扫码下载，开启安全沟通</div>
              </div>
            </div>
            <div class="down-btn-cls" slot="reference">
              <img :src="hoveredButton === 'ios' ? require('@/assets/newpc/ios_on.png') : require('@/assets/newpc/ios_default.png')"
                   @mouseover="hoveredButton = 'ios'" @mouseleave="hoveredButton = null" alt="iOS下载按钮" class="img-cls">
            </div>
          </el-popover>
          <el-popover placement="top" trigger="hover" popper-class="download-popover">
            <div class="down-item">
              <div class="down-hide">
                <img src="@/assets/qrcode_and.png" alt="Android应用下载二维码" class="qr-img-cls" />
                <div style="font-weight: bold">扫码下载，开启安全沟通</div>
              </div>
            </div>
            <div class="down-btn-cls" slot="reference">
              <img :src="hoveredButton === 'and' ? require('@/assets/newpc/and_on.png') : require('@/assets/newpc/and_default.png')"
                   @mouseover="hoveredButton = 'and'" @mouseleave="hoveredButton = null" alt="Android下载按钮" class="img-cls">
            </div>
          </el-popover>
          <div class="down-btn-cls">
            <img :src="hoveredButton === 'windows' ? require('@/assets/newpc/windows_on.png') : require('@/assets/newpc/windows_default.png')"
                 @mouseover="hoveredButton = 'windows'" @mouseleave="hoveredButton = null" @click="download('windows')" alt="Windows下载按钮" class="img-cls">
          </div>
          <div class="down-btn-cls">
            <img :src="hoveredButton === 'mac' ? require('@/assets/newpc/mac_on.png') : require('@/assets/newpc/mac_default.png')"
                 @mouseover="hoveredButton = 'mac'" @mouseleave="hoveredButton = null" @click="download('mac')" alt="Mac下载按钮" class="img-cls">
          </div>
        </div>
      </div>
      <footer>
        <div class="recharge-entry">
          <div class="recharge-text">
            <span class="recharge-badge">快捷入口</span>
            <strong>默往币充值</strong>
            <p>充值入口已开启，点击即可进入。</p>
          </div>
          <a
            class="recharge-link"
            href="/coin/recharge?screen=full"
            target="_blank"
            rel="noopener noreferrer"
          >
            立即充值
          </a>
        </div>
        <nav class="footer-nav">
          <router-link to="/">首页</router-link>
          <span class="nav-sep">|</span>
          <router-link to="/features">功能特性</router-link>
          <span class="nav-sep">|</span>
          <router-link to="/download">下载APP</router-link>
        </nav>
        <p>默往使用规范 | 客服热线: 400-600-8017</p>
        <p>Copyright ◎ 2019-2020 厦门默往科技有限公司
          <a style="margin-left: 8px" target="_blank" href="http://beian.miit.gov.cn/">
            {{ currentIcp }}          </a></p>
        <p><a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020302033744"
        > <img src="http://www.beian.gov.cn/img/new/gongan.png" alt="公安网安备案图标" style="position: relative;top: 5px"> 闽公网安备 35020302033744号

        </a></p>
      </footer>
    </div>
  </div>
</template>

<script>
import {getDownUrl} from "@/api/apply";

export default {
  name: "index",
  metaInfo: {
    title: '默往 IM - 端到端加密聊天软件 | 私密安全通讯 APP',
    meta: [
      { 
        vmid: 'keywords',
        name: 'keywords', 
        content: '加密聊天软件，端到端加密 APP，私密通讯，安全聊天，隐私保护，默往 IM，Mowang' 
      },
      { 
        vmid: 'description',
        name: 'description', 
        content: '默往是一款面向亲密关系与可信联系人的私密加密通信应用。端到端加密、多层防护、应用锁、截屏检测，支持 2000 人超级群。私密沟通，安心连接。' 
      },
      { vmid: 'author', name: 'author', content: '厦门默往科技有限公司' },
      { vmid: 'robots', name: 'robots', content: 'index, follow' },
      { vmid: 'renderer', name: 'renderer', content: 'webkit' },
      // Open Graph
      { vmid: 'og:title', property: 'og:title', content: '默往 IM - 端到端加密聊天软件 | 私密安全通讯 APP' },
      { vmid: 'og:description', property: 'og:description', content: '端到端加密、多层防护、应用锁、截屏检测，支持 2000 人超级群' },
      { vmid: 'og:type', property: 'og:type', content: 'website' },
      { vmid: 'og:url', property: 'og:url', content: 'https://www.mowangim.com/' },
      { vmid: 'og:image', property: 'og:image', content: 'https://www.mowangim.com/images/og-image.jpg' },
      // Twitter Card
      { vmid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
      { vmid: 'twitter:title', name: 'twitter:title', content: '默往 IM - 端到端加密聊天软件 | 私密安全通讯 APP' },
      { vmid: 'twitter:description', name: 'twitter:description', content: '端到端加密、多层防护、应用锁、截屏检测' }
    ],
    link: [
      { vmid: 'canonical', rel: 'canonical', href: 'https://www.mowangim.com/' }
    ]
  },
  data() {
    return {
      useList: [
        {
          icon: require('@/assets/newpc/icon_1.png'),
          title: '端对端加密，保障通信安全',
          msg: '采用端到端加密(E2EE)技术，您的每一条消息都经过高强度加密。只有参与通信的双方能够查看，任何第三方均无法触及您的内容。'
        },
        {
          icon: require('@/assets/newpc/icon_2.png'),
          title: '纵深防御，构筑安全堡垒',
          msg: '从网络传输加密到本地存储加密，再结合应用锁功能，构建多重安全防线。为您的重要谈话提供专业的安全防护，确保万无一失。'
        },
        {
          icon: require('@/assets/newpc/icon_3.png'),
          title: '智能语音转文本，沟通更高效',
          msg: '智能语音识别技术，发送语音时可选择转为文字或“语音+文字”组合，满足不同场景沟通需求，让信息传递更加精准高效。'
        },
        {
          icon: require('@/assets/newpc/icon_4.png'),
          title: '超级群管理，秩序与安全并存',
          msg: '支持2000人大型群组，配备完善的群管理工具。包括截屏监测、成员保护、消息管理等多项功能，让您管理大规模社群轻松高效。'
        }
      ],
      hoveredButton: null,
      downloadUrls: {
        android: '',
        mac: '',
        windows:''
      },
      icpMap: {
        'www.xmzyqkj.cn': '闽ICP备19013876号-2',
        'www.xmzyqkj.com': '闽ICP备19013876号-1',
        'www.mwmws.com': '闽ICP备19013876号-24',
        'www.mwkss.com': '闽ICP备19013876号-25',
        'www.mokaparty.cn': '闽ICP备19013876号-18',
        'www.mowangim.com': '闽ICP备18014382号',
        'www.xmkefu.com': '闽ICP备19013876号-21'
      }
    };
  },
  created() {
    this.initDownUrl();
  },
  computed: {
    currentIcp() {
      const hostname = window.location.hostname;
      return this.icpMap[hostname] || '闽ICP备18014382号';
    }
  },
  methods: {
    initDownUrl () {
      getDownUrl().then(res => {
        this.downloadUrls = res.data;
        this.downloadUrls.windows = res.data.pc;
      }).catch(err => {
        console.error('获取下载链接失败', err);
      })
    },
    download (platform) {
      const url = this.downloadUrls[platform] || platform;
      if (url) {
        window.open(url, '_blank');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.flex-box {
  display: flex;
  align-items: center;

  .flex-1 {
    flex: 1;
  }
}
.page-container {
  background-image: url("../assets/newpc/bg_1.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-color: #EAFFFC;
}
.page-content {
  padding-top: 30px;

  .logo-cls {
    width: 121px;
    margin-left: 10%;
  }
}

.down-hide{
  text-align: center;
}

.qr-img-cls{
  height: 200px;
  width: 200px;
}

.down-btn-cls {
  width: 160px;
  height: 72px;
  cursor: pointer;
  position: relative;
  margin-right: 20px;

  .img-cls {
    width: 160px;
    position: absolute;
    left: 0;
    top: 0;
    transition: opacity 0.3s ease-in-out;
  }

  .on-cls {
    opacity: 0;
  }
}

.down-btn-cls:first-child {
  margin-right: 20px;
}

.down-btn-cls:hover {
  .on-cls {
    opacity: 1;
  }
}

.content-1 {
  font-size: 18px;
  color: #323232;
  width: 1360px;
  margin: 0 auto;

  .content-flex-1 {
    padding: 4.5% 0;
    justify-content: center;
  }

  .banner-2 {
    width: 35%;
    margin: 0 20px 0 12%;
  }

  h1 {
    font-size: 28px;
    color: #040027;
  }

  h2 {
    font-size: 18px;
    color: #040027;
    font-weight: 600;
  }

  p {
    padding: 18px 0;
    width: 100%;
  }

  .mar-top {
    margin-top: 15px;
  }
}

.content-2 {
  text-align: center;
  padding: 2% 0 4%;
  width: 1360px;
  margin: 0 auto;

  h1 {
    font-size: 36px;
  }

  h2 {
    font-size: 36px;
    color: #040027;
  }

  .sub-title-cls {
    font-size: 24px;
    color: #4C4C4C;
    margin: 32px auto;
    justify-content: center;

    li {
      padding: 0 20px;
    }
  }

  .use-list-cls {
    .use-item-cls {
      border: 1px solid #C7F7FF;
      border-radius: 24px;
      font-size: 14px;
      color: #040027;
      background: #fff;
      padding: 20px;
      margin: 0 9px;
      height: 186px;

      .icon-cls {
        width: 60px;
        height: 60px;
      }

      h4 {
        font-size: 18px;
        padding: 15px 0;
      }
    }

    //.use-item-cls:hover {
    //  background: #B3FFE8;
    //}
  }
}

.content-3,
.content-4,
.content-5,
.content-6,
.content-7 {
  padding: 1% 0;
  font-size: 18px;
  color: #6A6A6A;

  .banner-3,
  .banner-5,
  .banner-7 {
    width: 40%;
    margin-left: -30px;
  }

  h2 {
    color: #040027;
    font-size: 32px;
  }

  h3 {
    color: #040027;
    font-size: 28px;
  }

  h4 {
    color: #040027;
    font-size: 28px;
  }

  p {
    padding: 20px 0;
    line-height: 32px;

    span {
      color: #040027;
      font-weight: bold;
    }
  }
}

.content-3,
.content-5,
.content-7 {
  background-color: #fff;

  > .flex-box {
    width: 1360px;
    margin: 0 auto;

    .flex-1 {
      padding-left: 80px;
    }
  }
}

.content-4,
.content-6 {
  width: 1360px;
  margin: 0 auto;
  padding: 1% 0;

  .banner-4 {
    width: 35%;
    margin: 0 100px;
  }

  .banner-6 {
    width: 40%;
  }
}

.content-5 {
  padding: 0;
}

.content-7 {
  padding-bottom: 0;
}

.gradient-box {
  width: 100%;
  height: 100px;
  background: linear-gradient(to bottom, white, transparent);
  position: relative;
  z-index: 2;
}

.bottom-box {
  background-image: url("../assets/newpc/bg_bottom.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
  padding: 8% 0 5%;
  margin-top: -100px;
  background-color: #CEF3E8;

  .btm-cls {
    margin-left: 40%;
    font-size: 20px;
    color: #6A6A6A;
    padding: 100px 0 20px;

    h1 {
      font-size: 36px;
      color: #040027;
    }

    h2 {
      font-size: 36px;
      color: #040027;
    }

    p {
      padding: 20px 0;
      width: 70%;
    }
  }

  footer {
    font-size: 14px;
    color: #6D6F76;
    text-align: center;
    line-height: 26px;
    padding-top: 2%;

    .recharge-entry {
      width: 920px;
      margin: 0 auto 28px;
      padding: 22px 40px;
      border-radius: 24px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.92), rgba(243, 255, 251, 0.95));
      // box-shadow: 0 12px 30px rgba(4, 0, 39, 0.06);
      border: 1px solid #05d496;
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: left;
    }

    .recharge-text {
      strong {
        display: block;
        margin: 10px 0 6px;
        font-size: 28px;
        line-height: 1.2;
        color: #040027;
      }

      p {
        width: 100%;
        padding: 0;
        margin: 0;
        color: #6A6A6A;
        font-size: 16px;
        line-height: 28px;
      }
    }

    .recharge-badge {
      display: inline-flex;
      align-items: center;
      padding: 6px 14px;
      border-radius: 999px;
      background: #E8FFF7;
      color: #0E8F73;
      font-size: 14px;
      font-weight: 600;
      border: 1px solid rgba(14, 143, 115, 0.12);
    }

    .recharge-link {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 176px;
      height: 54px;
      padding: 0 28px;
      border-radius: 18px;
      background: #05d496;
      color: #fff;
      font-size: 18px;
      font-weight: 600;
      border: 1px solid rgba(14, 143, 115, 0.12);
      box-shadow: 0 10px 24px rgba(14, 143, 115, 0.12);
      transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
    }

    // .recharge-link:hover {
    //   color: #040027;
    //   transform: translateY(-2px);
    //   background: #9AF5DA;
    //   box-shadow: 0 14px 28px rgba(14, 143, 115, 0.16);
    // }

    a {
      color: #6D6F76;
    }

    .footer-nav {
      margin-bottom: 12px;

      a {
        color: #6D6F76;
        text-decoration: none;
        padding: 0 8px;
        transition: color 0.2s;

        &:hover {
          color: #040027;
        }
      }

      .nav-sep {
        color: #ccc;
      }
    }
  }
}
</style>
